module.exports = __webpack_public_path__ + "static/media/footer-arrow.8ce8beef.svg";